import * as React from 'react';

type SwitchHookReturnType = {
  value: boolean;
  toggle: () => void;
  on: () => void;
  off: () => void;
};

export function useSwitch2(initialState: boolean): SwitchHookReturnType {
  const [value, setValue] = React.useState(initialState);
  const toggle = () => setValue(!value);
  const on = () => setValue(true);
  const off = () => setValue(false);
  return { value, toggle, on, off };
}
